import { Component, HostListener, OnInit } from '@angular/core';
import {Config} from './services/env.config';
import {PlatformLocation} from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import {ServerBranch} from '../assets/serverBranch';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'd2d-ecom';
  rsso: any;
  constructor(private http: HttpClient,platformLocation: PlatformLocation,private router: Router, private route: ActivatedRoute, public authService: AuthService) {
  

      if (ServerBranch.typeOfServer == 'Test') {
          Config.BaseEndpoint = ServerBranch.BaseEndpoint;
          Config.LoginEndpoint = ServerBranch.LoginEndpoint;
          Config.LogoutEndpoint = ServerBranch.LogoutEndpoint;
          Config.ImageEndpoint = ServerBranch.ImageEndpoint;
    } else if (ServerBranch.typeOfServer == 'Production') {


      Config.BaseEndpoint = "https://ibdindents.titan.in/IBD_DealerPortal_web/WcfDealerPortal.svc";
      Config.LoginEndpoint = "https://ibdindents.titan.in/IBD_DealerPortal_web/WcfDealerPortal.svc";
      Config.LogoutEndpoint = "https://ibdindents.titan.in/LoginPage.aspx";
      Config.ImageEndpoint =  'https://ibdindents.titan.in/IBD_DealerPortal_web/';



      // Config.BaseEndpoint = "https://connect.titan.in/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc";
      // Config.LoginEndpoint = "https://connect.titan.in/DealerDelight_web/DealerPortal_web/WcfDealerPortal.svc";
      // Config.LogoutEndpoint = "https://connect.titan.in/LoginPage.aspx";
      // Config.ImageEndpoint =  'https://connect.titan.in/DealerDelight_web/DealerPortal_web/';
   }
    
    this.route.queryParamMap.subscribe(queryParams => {
      let  id = { UserName: queryParams.get('UserName') , DealUserName: queryParams.get('UserName'), TokenId : queryParams.get('Token')};
      if(queryParams.get('Token')) {
        this.rsso = queryParams.get('RSSO');
        if (this.rsso == "1") {
          this.rsso = true;
        } else {
          this.rsso = false;
        }
        sessionStorage.setItem('RSSO', this.rsso);
        sessionStorage.setItem('Status', 'true');
        //this.authService.isLoggedIn = true;
        sessionStorage.setItem('user', JSON.stringify(id));
        this.router.navigate(['/home']);
      }
     
    });
  }
  ngOnInit(): void {
 
  }
  
  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHandler(event) {
  //   // Perform logout action here
  
  //   setTimeout(() => {
  //     this.authService.logout();
  //   }, 2000); // 2000 milliseconds = 2 seconds
  // }
  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'

    })
  };
  logout() {
    let sessionData = JSON.parse(sessionStorage.getItem('user')) ;
   
    let user = { UserName : sessionData.UserName }; 
    this.http
//IBDIENTS
   // this.http.post(Config.BaseEndpoint + '/CheckLogoutUser' , JSON.stringify(user), this.cpHeaders)
 //UAT
     .post(ServerBranch.BaseEndpoint  + '/CheckLogoutUser', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response) => {
        // Handle the API response
        
        this.router.navigate(['/login']);
        sessionStorage.clear();
        localStorage.clear();
       
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
        //this.messageService.errorMessage(error.error_msg, 'error');
      });
  }

}
